module.exports = __webpack_public_path__ + "/images/screen-vendedores-ofertas.e343de2.webp";